import { createModule } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';
import { triggerPublicEvent, PublicEvents } from '@project/shared/utils/events/js/events';

@createModule('StageCrisis')
/**
 * Stage Brand module implementation.
 */
export class StageCrisis extends TerrificSpec {
	start(resolve: () => void) {

		resolve();
	}

	stop() {
		// Stop
	}

	_triggerChangeEvent() {
		triggerPublicEvent(PublicEvents.uxChange, this, this._ctx);
	}
}
